import React from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'

const DeactiveButtons = ({ setConfirmOpen }) => {
  const { t } = useTranslation();
  const userData = useSelector((state) => state?.auth?.user?.user)

  return (
    <>
      <div className="s-buttons d-flex pb-3 mx-3 mt-3">
        <button
          className="btn fw-bold text-white shadow w-50  me-2 "
          type="button"
          data-bs-toggle="button"

          onClick={() => setConfirmOpen({
            type: true,
            status: "Deactive"
          })}
        >
          {userData?.is_deactivated ? t("activateAccount") : t("deactivateAccount")}
        </button>
        <button
          className="btn fw-bold text-white shadow w-50 ms-2"
          type="button"
          data-bs-toggle="button"
          onClick={() => setConfirmOpen({
            type: true,
            status: "Delete"
          })}
        >
          {t('deleteAccount')}
        </button>
      </div>
    </>
  )
}

export default DeactiveButtons